import {
  PageHeader,
  Tabs,
  Tag,
  Table,
  Select,
  Tooltip,
  Button,
  Radio,
  Row,
  Col,
  Spin,

} from "antd";
import Column from "antd/lib/table/Column";
import React, { Component } from "react";

import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import { getTableService } from "../services/table-helper.service";
import Dialog from "../shared/dialog";
import ReactToPrint from "react-to-print";

import { BrowserRouter as Router, Link, Switch } from "react-router-dom";
import BoardsReport from "./BoardsReport";

const { Option } = Select;
const pageStyle = `
  @page {
    size:A3 ;
    height:100% !important;
    width:100% !important;
    margin: 20mm;

  }
  @media all {
    .pagebreak {
      display: none;
    }
  }


  @media print {
    size:A4 landscape;
    html, body {
      position::relative;
      height:100% !important;
      width:100% !important;
      margin: 0;
    }

    .pagebreak {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
      overflow: visible; 
    }
  }
`;
const getRowKey = (record) => {
  return `${record.EmpId}`;
};
class SecondTabForBoards extends Component {
  constructor(propsName) {
    super(propsName);
    this.inputRef = React.createRef();

    this.state = {
      language: localStorage.getItem('Language'),
      EmpListDatasource: [],
      SectorListDatasource: [],
      Columns: [],
      ColumnsDatasourceTH: [],
      ColumnReportCount: [],
      ColumnsDatasourceEN: [],
      ColumnsReport: [],
      ColumnsDataReportTH: [],
      ColumnsDataReportEN: [],
      PositionList: [],
      SectorList: [],
      query: "",
      results: [],
      resultsAnsList: [],
      selectedRowKeys: null,
      visible: false,
      triggprint: true,
      ansDefault: [],
      evalStatus: "",
      five: [],
      four: [],
      three: [],
      two: [],
      one: [],
      //RUN 05/06/2021 เพิ่ม total เพื่อนำไปใช้ในการหา Percentage
      total: 0,
      spinner: false
    };

    this.AnsData = {
      assessor: localStorage.getItem("EmpId"),
      ansForm: []
    }

    // console.log("this.props in second tab", this.props.propsName);
    this.dialog = new Dialog();

  }


  componentWillReceiveProps(nextProps) {
    // console.log("nextProps", nextProps.propsName.lang);
    this.setState({ language: nextProps.propsName.lang });
    localStorage.setItem("Language", nextProps.propsName.lang);
  }



  
  componentDidMount() {
    // console.log("componentRef", this.inputRef);

    //fetch ans list
    this.spinnerControl();

    fetch(process.env.REACT_APP_API_URL + "/api/getAnsConfirmLevel", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        AssessorId: localStorage.getItem("EmpId"),
        // AssessorId: 772,
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        console.log("result for boards", result);
        result.forEach((element) => {
          this.state.ansDefault = element.AnsForm;
        });

        //RUN: นำ ans data เข้าไปใส่ใน array ที่ใช้ ิวิ่งข้อมูล Default
        if (this.state.ansDefault.length > 0) {

          this.state.ansDefault.forEach((e) => {
            this.AnsData.ansForm.push({
              empid: e.EmpId,
              assessor: e.Assessor,
              Point: e.Point,
            });
          });
        }

        this.setState({
          ansDefault: this.state.ansDefault,
          evalStatus: result[0].EvaluteStatus

        });
        // console.log(
        //   "this.state.ansDefault",
        //   this.state.ansDefault
        // );      
        // console.log("evalStatus", this.state.evalStatus);


        var five = this.AnsData.ansForm.filter(
          (e) => (e.Point == 5)
        );

        var four = this.AnsData.ansForm.filter(
          (e) => (e.Point == 4)
        )
        var three = this.AnsData.ansForm.filter(
          (e) => (e.Point == 3)
        )
        var two = this.AnsData.ansForm.filter(
          (e) => (e.Point == 2)
        )
        var one = this.AnsData.ansForm.filter(
          (e) => (e.Point == 1)
        )

        this.setState({ five: five, four: four, three: three, two: two, one: one })

      });

    //fetch emp list
    fetch(process.env.REACT_APP_API_URL + "/api/getUnderPrimaryByConfirmId", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
        // empid: 772
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        // console.log("result", result);
        result.forEach((element) => {
          this.state.EmpListDatasource = element.EmpList;
          this.state.SectorListDatasource = element.SectorList;
          this.state.results = element.EmpList;
          //RUN 05/06/2021 เพิ่ม total เพื่อนำไปใช้ในการหา Percentage
          this.state.total = this.state.EmpListDatasource.length
        });
        this.state.EmpListDatasource.forEach((e) => {
          if (this.state.PositionList.length == 0) {
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          } else {
            this.state.PositionList = this.positionPopper(e.PositionNameTH);
            this.state.PositionList.push({
              PositionNameTH: e.PositionNameTH,
              PositionNameEN: e.PositionNameEN,
            });
          }
          // // console.log("EmpListDatasource", e.PositionNameTH);
        });
        this.setState({
          EmpListDatasource: this.state.EmpListDatasource,
          results: this.state.results,
          SectorListDatasource: this.state.SectorListDatasource,
          PositionList: this.state.PositionList,
        });
        this.state.SectorListDatasource.forEach((e) => {
          let statusSec = this.sectorStatus(e.SectorId)
          if (statusSec == true) {
            e.color = '#77dd77'
            e.TextColor = 'green'
            
          } else {
            e.color = 'inherit'
            e.TextColor = 'black'

          }
        })

        console.log('get seelectorrr', this.state.SectorListDatasource)
        // // console.log(
        //   "this.state.ColumnsDatasourceTH",
        //   this.state.ColumnsDatasourceTH
        // );
        // console.log(
        //   "this.state.SectorListDatasource",
        //   this.state.SectorListDatasource
        // );
        // // console.log("this.state.PositionList", this.state.PositionList);
        this.spinnerControl();

      });

    // get data column
    getTableService("step-two-boards").then((result) => {
      var table = [];
      result.forEach((e) => {
        this.state.Columns = e.TableColumn;
      });
      console.log("this.state.Columns", this.state.Columns);
      // render thai 
      this.state.Columns.forEach((e) => {
        // // console.log("ColumnKeyTH", e.ColumnKeyTH);
        if (e.ColumnKeyTH !== "StepPointAdmin" && e.ColumnKeyTH !== "SumAssessorCalPoint"
          && e.ColumnKeyTH !== "StepPoint" && e.ColumnKeyTH !== "SumSelfEval") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyTH == "StepPointAdmin") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                // // console.log('e in PrimaryEvaluteStatus', e)
                // // console.log('record in PrimaryEvaluteStatus', record)
                return (
                  <div>
                    <p> ยังไม่ได้ประเมินผู้ใต้สังกัด </p>
                  </div>
                );
              } else {

                return (

                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            }

          });
        }
        else if (e.ColumnKeyTH == "SumAssessorCalPoint") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                // // console.log("e in PrimaryEvaluteStatus", e);
                // // console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> ยังไม่ได้ประเมินผู้ใต้สังกัด </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        }
        else if (e.ColumnKeyTH == "StepPoint") {

          var estatus = [];
          this.state.ansDefault.forEach((e) => {
            return e.EvaluateStatus
          })

          // console.log('estatus', estatus)

          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            className: 'colStep',
            render: (e, record) => {
              if (this.state.evalStatus == '2' || record.GroupPostionId == 'F') {
                console.log('in', record)
                console.log('this.state', this.state)
                // console.log(' in step point 2')
                // // console.log('record.EvaluateStatus',  record.EvaluateStatus)
                return (
                  <div>
                    {/* <div>เปิดในวันที่ 25/04/2022</div> */}
                    <Radio.Group
                      name="step-point"
                      buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                      disabled
                    >
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              } else {
                // console.log(' in step point 1 record', record.GroupPostionId)

                return (
                  <div
                    onChange={(e) => {
                      this.handleChange(
                        record.EmpId,
                        this.AnsData.assessor,
                        e.target.value
                      );
                    }}
                  >
                    {/* <div>เปิดในวันที่ 25/04/2022</div> */}
                    <Radio.Group
                      name="step-point"
                      buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                    >
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              }


            },
          });

        }
        else if (e.ColumnKeyTH == "SumSelfEval") {
          this.state.ColumnsDatasourceTH.push({
            title: e.ColumnNameTH,
            dataIndex: e.ColumnKeyTH,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                // // console.log("e in PrimaryEvaluteStatus", e);
                // // console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> ยังไม่ได้ประเมินตนเอง </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        }
      });

      this.setState({
        ColumnsDatasourceTH: this.state.ColumnsDatasourceTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        )
      });

      //render en
      this.state.Columns.forEach((e) => {
        // // console.log("ColumnKeyEN", e.ColumnKeyEN);
        if (e.ColumnKeyEN !== "StepPoint" && e.ColumnKeyEN !== "StepPointAdmin" && e.ColumnKeyEN !== "SumAssessorCalPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
          });
        } else if (e.ColumnKeyEN == "StepPointAdmin") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                // console.log('e in PrimaryEvaluteStatus', e)
                // // console.log('record in PrimaryEvaluteStatus', record)
                return (
                  <div>
                    <p> No record </p>
                  </div>
                );
              } else {

                return (

                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        }
        else if (e.ColumnKeyEN == "SumAssessorCalPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                // // console.log('e in PrimaryEvaluteStatus', e)
                // // console.log('record in PrimaryEvaluteStatus', record)
                return (
                  <div>
                    <p> No record </p>
                  </div>
                );
              } else {

                return (

                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          });
        }
        else if (e.ColumnKeyEN == "StepPoint") {
          this.state.ColumnsDatasourceEN.push({
            title: e.ColumnNameEN,
            dataIndex: e.ColumnKeyEN,
            OrderBy: e.ColumnOrder,
            className: "colStep",
            render: (e, record) => {
              if (this.state.evalStatus == '2' || record.GroupPostionId == 'F') {
                return (
                  <div>
                    {/* <div>Avalaible on 25/04/2022</div> */}
                    <Radio.Group name="step-point" buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}
                      disabled>
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              } else {
                return (
                  <div
                    onChange={(e) => {
                      this.handleChange(
                        record.EmpId,
                        this.AnsData.assessor,
                        e.target.value
                      );
                    }}
                  >
                    {/* <div>Available on 25/04/2022</div> */}
                    <Radio.Group name="step-point" buttonStyle="solid"
                      defaultValue={this.getDefaultScore(
                        record.EmpId,
                        this.AnsData.assessor
                      )}>
                      <Radio.Button value={5}>5</Radio.Button>
                      <Radio.Button value={4}>4</Radio.Button>
                      <Radio.Button value={3}>3</Radio.Button>
                      <Radio.Button value={2}>2</Radio.Button>
                      <Radio.Button value={1}>1</Radio.Button>
                    </Radio.Group>
                  </div>
                );
              }


            },
          });
        }
      });
      this.state.ColumnReportCount.push({
        title: 'ระดับผลปฎิบัติงาน',
        dataIndex: 'counting',
        className: 'reporthead reportcolumn reporttd',
        children: [{
          title: '1',
          dataIndex: '1',
          className: 'reporthead reportcolumn reporttd',
          OrderBy: 1,
        },
        {
          title: '2',
          dataIndex: '2',
          className: 'reporthead reportcolumn reporttd',
          OrderBy: 2,
        }, {
          title: '3',
          dataIndex: '3',
          className: 'reporthead reportcolumn reporttd',
          OrderBy: 3,
        }, {
          title: '4',
          dataIndex: '4',
          className: 'reporthead reportcolumn reporttd',
          OrderBy: 4,
        }, {
          title: '5',
          dataIndex: '5',
          className: 'reporthead reportcolumn reporttd',
          OrderBy: 5,
        }
          // , {
          //   title: 'รวม',
          //   dataIndex: 'รวม',
          //   className: 'reporthead reportcolumn reporttd',
          //   OrderBy: 6,
          // }
        ]
      },
        {
          title: 'จำนวน (คน)',
          dataIndex: 'counting',
          className: 'reporthead reportcolumn reporttd',
          children: [{
            title: this.state.one.length,
            dataIndex: this.state.one.length,
            className: 'reporthead reportcolumn reporttd',
            OrderBy: 1,
            render: (e, record) => {
              return (
                <div>
                  {this.state.one.length} dfdfbdfbdfbdfb
                </div>
              )
            }
          },
          {
            title: this.state.two.length,
            dataIndex: this.state.two.length,
            className: 'reporthead reportcolumn reporttd',
            OrderBy: 2,
          }, {
            title: this.state.three.length,
            dataIndex: this.state.three.length,
            className: 'reporthead reportcolumn reporttd',
            OrderBy: 3,
          }, {
            title: this.state.four.length,
            dataIndex: this.state.four.length,
            className: 'reporthead reportcolumn reporttd',
            OrderBy: 4,
          }, {
            title: this.state.five.length,
            dataIndex: this.state.five.length,
            className: 'reporthead reportcolumn reporttd',
            OrderBy: 5,
          }
          ]
        }

      )
      // this.state.ColumnsDatasourceTH.push({
      //   title: e.ColumnNameTH,
      //   dataIndex: e.ColumnKeyTH,
      //   OrderBy: e.ColumnOrder,
      // });
      this.setState({
        ColumnsDatasourceEN: this.state.ColumnsDatasourceEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
        ColumnReportCount: this.state.ColumnReportCount.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        )
      });
    });

    getTableService("boards-report").then((result) => {
      result.forEach((e) => {
        this.state.ColumnsReport = e.TableColumn;
      });
      console.log('dddddd', this.state.ColumnsReport)
      this.state.ColumnsReport.forEach((el) => {
        if (
          el.ColumnKeyTH !== "SumSelfEval" &&
          el.ColumnKeyTH !== "SumAssessorCalPoint" &&
          el.ColumnKeyTH !== "EmpId" &&
          el.ColumnKeyTH !== "OrderNo" &&
          el.ColumnKeyTH !== "NameAndLastTH" &&
          el.ColumnKeyTH !== "PositionNameTH" &&
          el.ColumnKeyTH !== "SectorNameTH" &&
          el.ColumnKeyTH !== "StepPoint" &&
          el.ColumnKeyTH !== "StepPointAdmin"
        ) {
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
          });
        }
        else if (el.ColumnKeyTH == "NameAndLastTH") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.FirstNameTH} {record.LastNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "SectorNameTH") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.SectorNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "PositionNameTH") {
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn',
            className: 'SubRepHead SubRepPositionCol SubRepPositionTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.PositionNameTH}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "OrderNo") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn reporttd HeadSort',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {index + 1}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "EmpId") {
          console.log("in empid");
          this.state.ColumnsDataReportTH.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyTH,
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "SumSelfEval") {
          this.state.ColumnsDataReportTH.push({
            title: 'คะแนนการประเมิน',
            dataIndex: 'คะแนนการประเมิน',
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            children: [{
              title: 'ประเมินตนเอง',
              width: '10px',
              dataIndex: 'SumSelfEval',
              className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        } else if (el.ColumnKeyTH == "SumAssessorCalPoint") {
          console.log('kkokd', this.state.ColumnsDataReportTH[5].children)
          this.state.ColumnsDataReportTH[5].children.push({
            title: 'ผู้บังคับบัญชาประเมิน',
            dataIndex: 'SumAssessorCalPoint',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',
            width: '2px',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              if (e == null) {
                console.log("e in PrimaryEvaluteStatus", e);
                console.log("record in PrimaryEvaluteStatus", record);
                return (
                  <div>
                    <p> </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          })

        } else if (el.ColumnKeyTH == "StepPointAdmin") {
          this.state.ColumnsDataReportTH.push({
            title: 'ระดับผลการปฏิบัติงาน',
            dataIndex: 'ระดับผลการปฏิบัติงาน',
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            children: [{
              title: 'คณบดี / หัวหน้าสำนักงาน/ ผู้อำนวยการ',
              width: '10px',
              dataIndex: 'StepPointAdmin',
              className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        }
        else if (el.ColumnKeyTH == "StepPoint") {
          console.log("in StepPointbv", this.state.ColumnsDataReportEN[5]);
          this.state.ansDefault.forEach((e) => {
            return e.EvaluateStatus
          })
          this.state.ColumnsDataReportTH[6].children.push({
            title: el.ColumnNameTH,
            dataIndex: 'StepPoint',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
            width: '2px',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              return (
                <div>
                  <p> {this.getDefaultScore(
                    record.EmpId,
                    this.AnsData.assessor
                  )}</p>
                </div>)
            },
          })
        }
      });

      this.setState({
        ColumnsDataReportTH: this.state.ColumnsDataReportTH.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        ),
      });

      this.state.ColumnsReport.forEach((el) => {
        if (
          el.ColumnKeyEN !== "SumSelfEval" &&
          el.ColumnKeyEN !== "SumAssessorCalPoint" &&
          el.ColumnKeyEN !== "EmpId" &&
          el.ColumnKeyEN !== "OrderNo" &&
          el.ColumnKeyEN !== "NameAndLastEN" &&
          el.ColumnKeyEN !== "PositionNameEN" &&
          el.ColumnKeyEN !== "SectorNameEN" &&
          el.ColumnKeyEN !== "StepPoint" &&
          el.ColumnKeyEN !== "StepPointAdmin"
        ) {
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameTH,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
          });
        }
        else if (el.ColumnKeyEN == "NameAndLastEN") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'SubRepHead SubRepColumn SubRepTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.FirstNameEN} {record.LastNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "SectorNameEN") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'SubRepHead SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.SectorNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "PositionNameEN") {
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn',
            className: 'SubRepHead SubRepPositionCol SubRepPositionTD HeadSort HeadersForReport TdForBoard',
            render: (e, record, index) => {
              return (
                <div>
                  {record.PositionNameEN}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "OrderNo") {
          console.log("in OrderNo");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            // className: 'reporthead reportcolumn reporttd HeadSort',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard',

            render: (e, record, index) => {
              return (
                <div>
                  {index + 1}
                </div>
              )
            }
            // defaultSortOrder: "descend",

            // sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyEN == "EmpId") {
          console.log("in empid");
          this.state.ColumnsDataReportEN.push({
            title: el.ColumnNameEN,
            dataIndex: el.ColumnKeyEN,
            OrderBy: el.ColumnOrder,
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            defaultSortOrder: "descend",
            sorter: (a, b) => a.EmpId - b.EmpId,
            sortDirections: ["descend", "ascend"],
          });
        }
        else if (el.ColumnKeyTH == "SumSelfEval") {
          this.state.ColumnsDataReportEN.push({
            title: 'Points of Work Performance',
            dataIndex: 'Points of Work Performance',
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            children: [{
              title: 'Self - Assessment',
              width: '10px',
              dataIndex: 'SumSelfEval',
              className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport HeadersLongRep TdForBoard',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        } else if (el.ColumnKeyTH == "SumAssessorCalPoint") {
          console.log('kkokd', this.state.ColumnsDataReportEN[5].children)
          this.state.ColumnsDataReportEN[5].children.push({
            title: 'Assessment by Supervisor',
            dataIndex: 'SumAssessorCalPoint',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport HeadersLongRep TdForBoard',
            width: '2px',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              if (e == null) {

                return (
                  <div>
                    <p> </p>
                  </div>
                );
              } else {
                return (
                  <div>
                    <p> {e} </p>
                  </div>
                );
              }
            },
          })

        } else if (el.ColumnKeyEN == "StepPointAdmin") {
          this.state.ColumnsDataReportEN.push({
            title: 'Level of work performance',
            dataIndex: 'Level of work performance',
            OrderBy: el.ColumnOrder,
            width: '10px',
            className: 'reporthead reportcolumn reporttd HeadSort HeadersForReport TdForBoard',
            children: [{
              title: 'Dean / Head / Director',
              width: '10px',
              dataIndex: 'StepPointAdmin',
              className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
              OrderBy: el.ColumnOrder,
              render: (e, record) => {
                if (record.EvaluateStatus == 1) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else if (record.EvaluateStatus == 2) {
                  return (
                    <div>
                      <p> </p>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <p> {e} </p>
                    </div>
                  );
                }
              },
            },

            ],


          });
        }
        else if (el.ColumnKeyEN == "StepPoint") {
          console.log("in StepPoint");
          this.state.ansDefault.forEach((e) => {
            return e.EvaluateStatus
          })
          this.state.ColumnsDataReportEN[6].children.push({
            title: el.ColumnNameEN,
            dataIndex: 'StepPoint',
            className: 'SubRepHeadWrap SubRepSecCol SubRepSecTD HeadSort HeadersForReport TdForBoard HeadersLongRep',
            width: '2px',
            OrderBy: el.ColumnOrder,
            render: (e, record) => {
              return (
                <div>
                  <p> {this.getDefaultScore(
                    record.EmpId,
                    this.AnsData.assessor
                  )}</p>
                </div>)
            },
          })
        }
      });
      this.setState({
        ColumnsDataReportEN: this.state.ColumnsDataReportEN.sort(
          (firstItem, secondItem) => firstItem.OrderBy - secondItem.OrderBy
        )
      });
      //this.spinnerControl();


    })



  }
  spinnerControl() {
    this.setState({ spinner: !this.state.spinner });
  }

  testarrayDupFunction(empid, assessor) {
    //this.spinnerControl();

    // console.log("testarrayDupFunction");
    var tempDup = [];
    //RUN: ยัดใส่เป็น ToString ให้หมดเนื่องจากส่งไปsave กับ ส่งคืนมา มีค่าdatatype อิอัยยยยยยยยยย 16/04/2021
    var tempempid = empid.toString();
    var tempassessor = assessor.toString();

    tempDup = this.AnsData.ansForm.filter((e) => {
      return (
        e.empid !== empid ||
        e.assessor !== assessor
      );
    });
    // console.log("tempDup", tempDup);
    //this.spinnerControl();

    return tempDup;
  }

  sectorStatus(SectorId) {
    console.log('sectorlistStatus', this.state.SectorListDatasource)
    console.log('EmpLIst', this.state.EmpListDatasource)
    let tempSectorForEmp = this.state.EmpListDatasource.filter(filt => {
      return filt.SectorId == SectorId
    })
    console.log(' this. tempstat.', this.state.ansDefault)
    let tempSecForEmp = this.state.ansDefault.filter(e => {
      return e.Sec_id == SectorId
    })
    console.log('tempSectorForEmplength', tempSectorForEmp.length)
    console.log('tempSecForEmplength', tempSecForEmp.length)
    if (tempSectorForEmp.length == tempSecForEmp.length) {
      return true
    } else {
      return false
    }
    // this.state.EmpListDatasource(e=>{ 

    // })

  }
  positionPopper(sectorName) {
    //this.spinnerControl();
    var tempDup = [];
    tempDup = this.state.SectorListDatasource.filter((e) => {
      return sectorName !== e.SectorId;
    });
    //this.spinnerControl(); 

    return tempDup;
  }

  getDefaultScore(empid, assessor) {
    //this.spinnerControl();
    var tempArray = [];
    tempArray = this.state.ansDefault.filter((e) => {
      return (
        e.EmpId == empid &&
        e.Assessor == assessor
      );
    });

    // // console.log('empid temp: ', empid)
    // // console.log('assessor temp: ', assessor)
    // // console.log('ansDefault temp: ', this.state.ansDefault)
    // // console.log('getDefaultScore temp: ', tempArray)

    if (tempArray.length > 0) {
      //this.spinnerControl();

      return tempArray[0].Point;
    } else {
      //this.spinnerControl();

      return null;
    }


  }

  getSearchResults = (query) => {
    //this.spinnerControl();

    const allData = this.state.results;
    const dataToShow = [];
    allData.forEach((item) => {
      // // console.log("item", item);
      const searchString = query;
      if (item.SectorId == searchString) {
        dataToShow.push(item);
      }
    });
    // console.log('data to show: ', dataToShow);
    this.setState({
      EmpListDatasource: dataToShow,
    });
    //this.spinnerControl();

  };

  handleSectorChange = (value) => {
    //this.spinnerControl();

    // console.log("handlePositionChange", value);
    this.setState(
      {
        query: value,
      },
      () => {
        if (this.state.query && this.state.query.length > 0) {
          // console.log("this.state.query", this.state.query);
          this.getSearchResults(this.state.query);
        } else {
          this.setState({
            EmpListDatasource: this.state.results,
          });
        }
      }
    );
    //this.spinnerControl();

  };

  handleSaveDraft = (ansSaveData) => {

    var empid;
    var assess;
    var point;

    ansSaveData.forEach((element) => {
      empid = element.empid;
      assess = element.assessor;
      point = element.Point;
    });

    // console.log("empid", empid);
    // console.log("assess", assess);
    // console.log("point", point);

    // console.log("ansSaveData", ansSaveData);

    fetch(process.env.REACT_APP_API_URL + "/api/saveFormFirstLevel", {
      method: "post",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: empid,
        formid: "2",
        assessor: assess,
        buttonaction: "1",
        jsonans: ansSaveData,
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        // console.log("save draft result: " + JSON.stringify(result));
        if (result.status == "404") {
          // alert("บันทึกไม่สำเร็จ");
          //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021


          if (this.state.language == 'TH') {
            this.dialog.WarningDialog('บันทึกร่างไม่สำเร็จ')
          } else {
            this.dialog.WarningDialog('Unable to Save Draft')
          }
        } else {

          if (this.state.language == 'TH') {
            this.dialog.SuccessDialogForDraft('บันทึกร่างสำเร็จ', '/assessing-subordinate')
            localStorage.setItem('defaultActiveKey', 2)

          } else {
            this.dialog.SuccessDialog('Save Draft Success', '/assessing-subordinate')
            localStorage.setItem('defaultActiveKey', 2)
          }
        }


      });
  };

  handleSubmit = (ansSaveData, EmpListDatasource) => {
    //RUN: ตรวจสอบ condition ว่ามีค่าจำนวน ans เท่ากับ form หรือไม่ 11/04/2012
    var tempArray = [];
    var tempArrayRemarkvalidation = [];

    // console.log('tempArrayRemarkvalidation',tempArrayRemarkvalidation)
    // console.log('ansform',ansSaveData)

    // console.log('ansSaveData.length',ansSaveData.length)
    // console.log('EmpListDatasource.length',EmpListDatasource.length)

    var tempEmpdata = EmpListDatasource.filter((e) => { return e.GroupPostionId !== 'F' })
    // console.log('tempEmpdata',tempEmpdata)

    //RUN: ใช้ Condition Nested If ให้เข้า Condition ให้ถูกต้อง และ แสดง error ขึ้นมาตามลำดับ 11/04/2021

    console.log('ansSaveData.length', ansSaveData.length)
    console.log('tempEmpdata.length.length', tempEmpdata.length)

    if (ansSaveData.length == tempEmpdata.length) {

      if (tempArrayRemarkvalidation.length == 0) {
        fetch(process.env.REACT_APP_API_URL + "/api/saveFormFirstLevel", {

          method: "post",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },

          body: JSON.stringify({
            empid: localStorage.getItem("EmpId"),
            formid: "2",
            assessor: localStorage.getItem("EmpId"),
            buttonaction: "2",
            jsonans: ansSaveData
          }),
        })
          .then((Response) => Response.json())
          .then((result) => {
            // console.log("submit result: " + JSON.stringify(result));
            if (result.status == "404") {
              // alert("บันทึกไม่สำเร็จ");
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021


              if (this.state.language == 'TH') {
                this.dialog.WarningDialog(
                  'บันทึกไม่สำเร็จ')
              } else {
                this.dialog.WarningDialog(
                  'Unable to Save')
              }
            } else {
              // alert("บันทึกสำเร็จ");
              // window.location.href = "/workform";
              //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

              if (this.state.language == 'TH') {
                this.dialog.SuccessDialog('บันทึกสำเร็จ', '/assessing-subordinate')
                localStorage.setItem('defaultActiveKey', 2)
              } else {
                this.dialog.SuccessDialog('Save Success', '/assessing-subordinate')
                localStorage.setItem('defaultActiveKey', 2)
              }

            }


          });
      } else {
        // alert(
        //   "บันทึกไม่สำเร็จ ข้อมูลเหตุผลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน"
        // );
        //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021
        if (this.state.language == 'TH') {
          this.dialog.WarningDialog(
            'บันทึกไม่สำเร็จ ข้อมูลเหตุผลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน')
        } else {
          this.dialog.WarningDialog(
            'Unable to save due to incomplete remark. Please check your assessment informations.')
        }

      }
    } else {
      // alert("บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน");
      //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021

      if (this.state.language == 'TH') {
        this.dialog.WarningDialog(
          'บันทึกไม่สำเร็จ ข้อมูลไม่ครบถ้วน กรุณาตรวจสอบข้อมูลการประเมิน')
      } else {
        this.dialog.WarningDialog(
          'Unable to save due to incomplete data. Please check your assessment informations.')
      }
    }
  };


  handleChange = (
    empid,
    assessor,
    value
  ) => {
    // console.log('in change')
    //this.spinnerControl();

    var temp = [];
    temp = this.AnsData.ansForm.filter((e) => {
      return (
        e.empid == empid &&
        e.assessor == assessor
      );
    });


    if (temp.length == 0) {
      this.AnsData.ansForm.push({
        empid: empid,
        assessor: assessor,
        Point: value
      });
    } else {
      this.AnsData.ansForm = this.testarrayDupFunction(
        empid,
        assessor
      );

      this.AnsData.ansForm.push({
        empid: empid,
        assessor: assessor,
        Point: value
      });
    }

    // console.log('ansForm', this.AnsData.ansForm)


    var five = this.AnsData.ansForm.filter(
      (e) => (e.Point == 5)
    );

    var four = this.AnsData.ansForm.filter(
      (e) => (e.Point == 4)
    )
    var three = this.AnsData.ansForm.filter(
      (e) => (e.Point == 3)
    )
    var two = this.AnsData.ansForm.filter(
      (e) => (e.Point == 2)
    )
    var one = this.AnsData.ansForm.filter(
      (e) => (e.Point == 1)
    )
    console.log('ionsss')
    this.setState({ five: five, four: four, three: three, two: two, one: one })
    //this.spinnerControl();

    // console.log('this.state.ansDefault in count', this.state.ansDefault)
    // console.log('five', this.state.five)
    // console.log('four', this.state.four.length)
    // console.log('three', this.state.three.length)
    // console.log('two', this.state.two.length)
    // console.log('one', this.state.one.length)

  };


  setRowKey(record) {
    //this.spinnerControl();

    const selectedRowKey = getRowKey(record);
    // console.log(selectedRowKey, typeof selectedRowKey);
    this.setState({ selectedRowKey });
    //this.spinnerControl();

  }

  renderContentTH() {
    const {
      EmpListDatasource,
      ColumnsDatasourceTH,
      PositionList,
      SectorListDatasource,
      five, four, three, two, one, total,
      ColumnReportCount,
      ColumnsReport,
      ColumnsDataReportTH
    } = this.state;
    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });
    console.log('ColumnReportCount', ColumnReportCount);
    return (
      <div style={{ padding: 15 }}>
        {/* render Left section */}
        <label style={{ paddingRight: 15 }}>เลือกตามสังกัด:</label>
        <Select
          placeholder="ทั้งหมด"
          bordered
          defaultValue={"ทั้งหมด"}
          style={{ width: '20em' }}
          // style={{ textAlign: 'center' }}

          onChange={(e) => this.handleSectorChange(e)}
        >
          <Option value={null}
            style={{ textAlign: 'center' }}

          > ทั้งหมด </Option>
          {SectorListDatasource.map((position) => (
            <Option value={position.SectorId}
              style={{ textAlign: 'center',color: position.TextColor,backgroundColor: position.color }}
            >{position.SectorNameTH}</Option>
          ))}
        </Select>


        {/* render Right sector */}
        <div>
          <label style={{ paddingRight: 15 }}>
            <b> จำนวนบุคลากรทั้งหมด </b> {EmpListDatasource.length} คน
          </label>
        </div>

        {this.renderCountTH()}


        <div>
          <div
            className="tab-centered "
          >

            <div
              style={{ float: "right" }}
            >

              <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => {
                  return (
                    <div
                      style={{
                        textAlign: "center",
                        marginBlock: 5,
                      }}
                    >
                      <Button type="primary">พิมพ์รายงานสรุป</Button>
                    </div>
                  );
                }}
                content={() => this.componentRefSummary}
              />

              <div
                style={{ display: "none" }}
              >

                <div ref={(el) => (this.componentRefSummary = el)}>
                  <div style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                    <h3 style={{ fontSize: '30px' }}>
                      ระดับผลการประเมินการปฎิบัติงานประจำปีการศึกษา 2564
                    </h3>
                    <h3> {tempSector.map((e) => e.SectorNameTH)}</h3>
                  </div>
                  <Row style={{ marginBottom: .1, marginTop: .1 }}>

                    <Col  >
                      <div >
                        <label style={{ paddingRight: 15 }}>
                          <h3 style={{ fontSize: '23px' }}> คณะวิชา/หน่วยงาน: {localStorage.getItem('DepartmentTH')} </h3>
                        </label>
                      </div>
                    </Col>

                  </Row>
                  <Row style={{ marginBottom: .1, marginTop: .1 }}>


                    <Col span={12}>
                      <div >
                        <label style={{ paddingRight: 15, }}>
                          <h3 style={{ fontSize: '23px' }}> จำนวนบุคลากรในสังกัด {EmpListDatasource.length} คน</h3>

                        </label>
                      </div>
                    </Col>

                  </Row>
                  <div className="tab-tablecen">
                    <table className="listforRep">
                      <tr>
                        <th className="headss" style={{ fontSize: '1.2em' }}>ระดับผลการปฏิบัติงาน</th>
                        <th className="headss" style={{ fontSize: '1.2em' }}>จำนวน (คน)</th>
                        <th className="headss" style={{ fontSize: '1.2em' }}>ร้อยละ</th>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>1</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{one.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(one.length / total * 100).toFixed(0)} </td>

                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>2</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{two.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(two.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>3</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{three.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(three.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>4</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{four.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(four.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>5</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{five.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(five.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>รวม</td>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>{one.length + two.length + three.length + four.length + five.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>{((one.length + two.length + three.length + four.length + five.length) / total * 100).toFixed(0)}</td>
                      </tr>
                    </table>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <div style={{ textAlign: "center", marginTop: 25 }}>
                        <p style={{ fontSize: '23px' }}> ลงชื่อ _________________________________</p>
                        <p style={{ fontSize: '23px' }}>

                          {"( " +
                            localStorage.getItem("TitleTH") +
                            " " +
                            localStorage.getItem("FirstNameTH") +
                            " " +
                            localStorage.getItem("LastNameTH") +
                            " )"}
                        </p>
                        <p style={{ fontSize: '23px' }}> ตำแหน่ง _______________________________</p>
                        <p style={{ fontSize: '23px' }}> วันที่ _________________</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="tab-secondBoard-centered ">
          {/* s */}
          <Table
            dataSource={EmpListDatasource}
            columns={ColumnsDatasourceTH}
            rowKey={(record) => getRowKey(record)}
            rowClassName={(record) =>
              getRowKey(record) === this.state.selectedRowKey
                ? "highlighted-selection"
                : ""
            }
            onRow={(record) => {
              return {
                onClick: () => {
                  this.setState({ visible: true });
                  this.setRowKey(record);
                },
              };
            }}
            pagination={false}
          >
            <Column />
          </Table>

        </div>



        {this.state.evalStatus == '2' ?

          <div>
            <ReactToPrint
              pageStyle={pageStyle}
              trigger={() => {
                return (
                  <div
                    style={{
                      textAlign: "center",
                      marginBlock: 5,
                    }}
                  >
                    <Button type="primary">พิมพ์รายงาน</Button>
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
            <div
              style={{ display: "none" }}
            >

              <div ref={(el) => (this.componentRef = el)}>
                <div style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                  <h3 style={{ fontSize: '2.5em' }}>
                    รายงานพิจารณาระดับผลการปฏิบัติงานบุคลากร ประจำปีการศึกษา
                    2564
                  </h3>

                </div>
                <Row style={{ marginBottom: .1, marginTop: .1 }}>
                  {/* render Left section */}
                  <Col span={12}>
                    <div>
                      <label style={{ paddingRight: 15 }}>
                        <b> จำนวนบุคลากรในสังกัด </b> {EmpListDatasource.length}
                        คน
                      </label>
                    </div>
                  </Col>

                  {/* render Right sector */}
                  <Col span={12}>{this.renderCountTH()}</Col>
                </Row>

                <div className="tab-centered ">
                  <Table
                    dataSource={EmpListDatasource}
                    columns={ColumnsDataReportTH}
                    pagination={false}
                  >
                    <Column />
                  </Table>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", marginTop: 25 }}>
                    <p> ลงชื่อ _________________________________</p>
                    <p>

                      {"( " +
                        localStorage.getItem("TitleTH") +
                        " " +
                        localStorage.getItem("FirstNameTH") +
                        " " +
                        localStorage.getItem("LastNameTH") +
                        " )"}
                    </p>
                    <p> ตำแหน่ง _______________________________</p>
                    <p> วันที่ _________________</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :

          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>

            <Button
              onClick={(e) => {
                this.handleSaveDraft(
                  this.AnsData.ansForm
                );
              }}
            >
              บันทึกร่าง
            </Button>


            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.EmpListDatasource
                );
              }}
            >
              ส่งข้อมูล
            </Button>



          </div>

        }

      </div>

    );

  }

  renderContentEN() {
    const {
      EmpListDatasource,
      ColumnsDatasourceEN,
      SectorListDatasource,
      ColumnsDataReportEN,
      five, four, three, two, one, total,

    } = this.state;
    var tempSector = SectorListDatasource.filter((e) => {
      return e.SectorId == this.state.sectorTH;
    });
    return (
      <div style={{ padding: 15 }}>

        <Row>
          {/* render Left section */}
          <Col span={12}>
            <label style={{ paddingRight: 15 }}>Choose by Sector:</label>
            <Select
              placeholder="All"
              bordered
              style={{ width: '20em' }}

              defaultValue={"All"}
              onChange={(e) => this.handleSectorChange(e)}
            >
              <Option value={null}
                style={{ textAlign: 'center' }}

              > All </Option>
              {SectorListDatasource.map((position) => (
                <Option value={position.SectorId}
                style={{ textAlign: 'center',color: position.TextColor,backgroundColor: position.color }}


                >{position.SectorNameEN}</Option>
              ))}
            </Select>


            {/* render Right sector */}
            <div>
              <label style={{ paddingRight: 15 }}>
                <b> Total </b> {EmpListDatasource.length}
              </label>
            </div>
          </Col>

          <Col span={12}>
            {this.renderCountEN()}
          </Col>
        </Row>
        <div>
          <div
            className="tab-centered "
          >

            <div
              style={{ float: "right" }}
            >

              <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => {
                  return (
                    <div
                      style={{
                        textAlign: "center",
                        marginBlock: 5,
                      }}
                    >
                      <Button type="primary">Print Summary Report</Button>
                    </div>
                  );
                }}
                content={() => this.componentRefSummary}
              />

              <div
                style={{ display: "none" }}
              >

                <div ref={(el) => (this.componentRefSummary = el)}>
                  <div style={{ textAlign: "center", marginTop: 100, marginBottom: 100 }}>
                    <h3 style={{ fontSize: '30px' }}>
                      Level of work performance results for Academic Year 2021
                    </h3>
                    <h3> {tempSector.map((e) => e.SectorNameTH)}</h3>
                  </div>
                  <Row style={{ marginBottom: .1, marginTop: .1 }}>

                    <Col  >
                      <div >
                        <label style={{ paddingRight: 15 }}>
                          <h3 style={{ fontSize: '23px' }}> Faculty/Department: {localStorage.getItem('DepartmentEN')} </h3>
                        </label>
                      </div>
                    </Col>

                  </Row>
                  <Row style={{ marginBottom: .1, marginTop: .1 }}>


                    <Col >
                      <div >
                        <label style={{ paddingRight: 15, }}>
                          <h3 style={{ fontSize: '23px' }}> Amount of people in the criteria to be considered: {EmpListDatasource.length} </h3>

                        </label>
                      </div>
                    </Col>

                  </Row>
                  <div className="tab-tablecen">
                    <table className="listforRep">
                      <tr>
                        <th className="headss" style={{ fontSize: '1.2em' }}>Level of work performance</th>
                        <th className="headss" style={{ fontSize: '1.2em' }}>Amount</th>
                        <th className="headss" style={{ fontSize: '1.2em' }}>Percentage</th>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>1</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{one.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(one.length / total * 100).toFixed(0)} </td>

                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>2</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{two.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(two.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>3</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{three.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(three.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>4</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{four.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(four.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>5</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{five.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.1em' }}>{(five.length / total * 100).toFixed(0)}</td>
                      </tr>
                      <tr>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>Total</td>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>{one.length + two.length + three.length + four.length + five.length}</td>
                        <td className="columnsss" style={{ fontSize: '1.2em' }}>{((one.length + two.length + three.length + four.length + five.length) / total * 100).toFixed(0)}</td>
                      </tr>
                    </table>

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                      <div style={{ textAlign: "center", marginTop: 25 }}>
                        <p style={{ fontSize: '23px' }}> Signature _________________________________</p>
                        <p style={{ fontSize: '23px' }}>

                          {"( " +
                            localStorage.getItem("TitleEN") +
                            " " +
                            localStorage.getItem("FirstNameEN") +
                            " " +
                            localStorage.getItem("LastNameEN") +
                            " )"}
                        </p>
                        <p style={{ fontSize: '23px' }}> Position _______________________________</p>
                        <p style={{ fontSize: '23px' }}> Date _________________</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="tab-secondBoard-centered ">
          <Table
            dataSource={EmpListDatasource}
            columns={ColumnsDatasourceEN}
            rowKey={(record) => getRowKey(record)}
            rowClassName={(record) =>
              getRowKey(record) === this.state.selectedRowKey
                ? "highlighted-selection"
                : ""
            }
            onRow={(record) => {
              return {
                onClick: () => {
                  this.setState({ visible: true });
                  this.setRowKey(record);
                },
              };
            }}
            pagination={false}
          >
            <Column />
          </Table>
        </div>

        {this.state.evalStatus == '2' ?
          <div>
            <ReactToPrint
              pageStyle={pageStyle}
              trigger={() => {
                return (
                  <div
                    style={{
                      textAlign: "center",
                      marginBlock: 5,
                    }}
                  >
                    <Button type="primary">Print Report</Button>
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
            <div style={{ display: "none" }}>
              {/* to print component */}
              <div ref={(el) => (this.componentRef = el)}>
                <div style={{ textAlign: "center" }}>
                  <h3>
                    Result of Work Performance Academic Year 2021
                  </h3>

                </div>

                <Row>
                  {/* render Left section */}
                  <Col >
                    <div>
                      <label style={{ paddingRight: 15 }}>
                        <b> Total </b> {EmpListDatasource.length}

                      </label>
                    </div>
                  </Col>

                  {/* render Right sector */}
                  <Col span={12}>{this.renderCountEN()}</Col>
                </Row>

                <div>
                  <Table
                    dataSource={EmpListDatasource}
                    columns={ColumnsDataReportEN}

                    pagination={false}
                  >
                    <Column />
                  </Table>
                </div>
                <div>

                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ textAlign: "center", marginTop: 25 }}>
                    <p> Signature _________________________________</p>
                    <p>
                      {" "}
                      {"( " +
                        localStorage.getItem("TitleEN") +
                        " " +
                        localStorage.getItem("FirstNameEN") +
                        " " +
                        localStorage.getItem("LastNameEN") +
                        " )"}
                    </p>
                    <p> Position _______________________________</p>
                    <p> Date _________________</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :

          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>

            <Button
              onClick={(e) => {
                this.handleSaveDraft(
                  this.AnsData.ansForm
                );
              }}
            >
              Draft
            </Button>


            <Button
              type="primary"
              onClick={(e) => {
                this.handleSubmit(
                  this.AnsData.ansForm,
                  this.state.EmpListDatasource
                );
              }}
            >
              Submit
            </Button>

          </div>
        }

      </div>

    );


  }

  renderCountTH() {
    {/* RUN 05/06/2021 นำ percentage ไปใส่ */ }

    const { five, four, three, two, one, total } = this.state

    return (
      <div style={{ textAlign: 'right' }}>
        <h4> <b>ระดับผลปฎิบัติงาน </b>  <br />
          5: {five.length} คน ({(five.length / total * 100).toFixed(2)}%)  | 4: {four.length} คน ({(four.length / total * 100).toFixed(2)}%) | 3: {three.length} คน ({(three.length / total * 100).toFixed(2)}%) | 2: {two.length} คน ({(two.length / total * 100).toFixed(2)}%) | 1: {one.length} คน ({(one.length / total * 100).toFixed(2)}%)</h4>
      </div>
    );
  }

  renderCountEN() {
    {/* RUN 05/06/2021 นำ percentage ไปใส่ */ }

    const { five, four, three, two, one, total } = this.state

    return (
      <div style={{ textAlign: 'right' }}>
        <h4> <b>Result of Work Performance </b>  <br />
          5: {five.length} ({(five.length / total * 100).toFixed(2)}%)  | 4: {four.length} ({(four.length / total * 100).toFixed(2)}%)  | 3: {three.length} ({(three.length / total * 100).toFixed(2)}%) | 2: {two.length} ({(two.length / total * 100).toFixed(2)}%) | 1: {one.length} ({(one.length / total * 100).toFixed(2)}%)  </h4>
      </div>
    );
  }








  render() {
    console.log("spiner", this.state.spinner);

    return (

      <div>
        <Spin tip="Loading..." spinning={this.state.spinner} >
          {this.state.language == 'TH'
            ? this.renderContentTH()
            : this.renderContentEN()}

        </Spin>

      </div>
    );

  }
}

export default SecondTabForBoards;
